var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "rp-header-logo" }, [
    _c("p", [
      _c("a", { attrs: { href: "https://cfdeknowledge.org/r/kc_landing" } }, [
        _c("img", { attrs: { src: _vm.kcLogo } }),
      ]),
      _c("span", [_vm._v("|")]),
      _c("img", { attrs: { src: _vm.cfdeLogo } }),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }